import './Stock.css';

function Stock() {
    return <div className="Stock">
        <h2>Stock Report for Today</h2>
    </div>
}
export default Stock;